import AdvancedCreditPolicy from './AdvancedCreditPolicy'

export default AdvancedCreditPolicy
